import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import * as Icons from "lucide-react";
import { API } from "../../App";

export const CAUSES_DEFAULTS = { eyebrow: "Community Hub", title: "Find help. Give help. Browse by cause.", cta_label: "All organizations", cta_url: "/community-hub", link_base: "/community-hub?cause=", max: 20 };

const iconFor = (name) => {
  const key = (name || "").split(/[-_ ]/).map((s) => s.charAt(0).toUpperCase() + s.slice(1)).join("");
  return Icons[key] || Icons.HeartHandshake;
};

export const HomeCauses = ({ block }) => {
  const cfg = { ...CAUSES_DEFAULTS, ...(block?.config || {}) };
  const [causes, setCauses] = useState([]);
  useEffect(() => { axios.get(`${API}/causes`).then((r) => setCauses((r.data || []).slice(0, Number(cfg.max) || 20))).catch(() => {}); }, [cfg.max]);
  return (
    <section className="bg-[#EFECE6] py-14 sm:py-20" data-testid="community-hub-section">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <p className="text-xs uppercase tracking-[0.2em] font-semibold text-[#E76F51]">{cfg.eyebrow}</p>
        <div className="mt-2 flex flex-wrap items-end justify-between gap-4">
          <h2 className="font-['Playfair_Display'] text-3xl sm:text-4xl font-bold text-[#2E5C55] leading-tight">{block?.title || cfg.title}</h2>
          {cfg.cta_label && <Link to={cfg.cta_url} className="inline-flex items-center gap-1.5 rounded-full border-2 border-[#2E5C55] px-4 py-2 text-sm font-bold text-[#2E5C55] hover:bg-[#2E5C55] hover:text-white transition-colors" data-testid="explore-causes-button">{cfg.cta_label} <Icons.ArrowRight className="h-4 w-4" /></Link>}
        </div>
        {block?.quip && <p className="mt-3 text-base text-[#5C5C5C] max-w-2xl">{block.quip}</p>}
        <div className="mt-8 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3" data-testid="cause-category-grid">
          {causes.map((c) => {
            const Icon = iconFor(c.icon);
            return (
              <Link key={c.id} to={`${cfg.link_base}${c.id}`} className="group flex items-center gap-3 rounded-xl bg-white border border-[#2E5C55]/10 p-3.5 shadow-sm hover:-translate-y-0.5 hover:shadow-md transition-[transform,box-shadow]" data-testid={`cause-${c.id}`}>
                <span className="grid h-10 w-10 shrink-0 place-items-center rounded-full text-white" style={{ backgroundColor: c.color || "#2E5C55" }}><Icon className="h-5 w-5" /></span>
                <span className="min-w-0"><span className="block text-sm font-extrabold text-[#1A1A1A] leading-tight">{c.name}</span>{c.description && <span className="block text-xs text-[#5C5C5C] line-clamp-1">{c.description}</span>}</span>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
};
